import React from 'react'
import { InputAdornment, TextField } from '@mui/material'
import { ReactComponent as Search } from "../../assets/img/search.svg"

const SearchBar = ({ customClass, handleChange }) => {
    return (
        <TextField
            fullWidth
            onChange={handleChange}
            placeholder='Search'
            slotProps={{
                input: {
                    startAdornment: <InputAdornment position="start"><Search /></InputAdornment>,
                },
            }}
            sx={{
                "input": {
                    padding: "12px 5px",
                    fontFamily: "Outfit",
                    color: "#828282",
                    fontWeight: 400
                },
                "& input::placeholder": {

                    opacity: 1,
                },
                ".MuiOutlinedInput-notchedOutline": {
                    border: "none",
                },
                "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    background: "white",

                },

            }} className={customClass} />
    )
}

export default SearchBar